// extracted by css-extract-rspack-plugin
export default {"searchInputWrapper":"PLHS9","resultsContainer":"gqJBX"};